import { useEffect } from 'react';
import type { TypeCommon } from './types/common';
import { RouterProvider } from 'react-router-dom';
import { createRouter } from './router';

function App() {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Tab') {
        const focusableElements = `
          input:not([disabled]),
          button:not([disabled]):not(.MuiTab-root):not([role="tab"]):not([role="tablist"] button)
        `;

        const elements = Array.from(
          document.querySelectorAll(focusableElements)
        )
          .filter((el: TypeCommon) => el.offsetParent !== null) // Check for visibility
          .filter(
            (el: TypeCommon) => el.clientWidth > 0 && el.clientHeight > 0
          ); // Ensure dimensions are greater than 0

        const firstElement: TypeCommon = elements[0];
        const lastElement: TypeCommon = elements[elements.length - 1];

        if (event.shiftKey) {
          // Shift + Tab
          if (
            document.activeElement === firstElement ||
            document.activeElement === document.body
          ) {
            event.preventDefault();
            lastElement.focus();
          }
        } else {
          // Tab
          if (
            document.activeElement === lastElement ||
            document.activeElement === document.body
          ) {
            event.preventDefault();
            firstElement.focus();
          }
        }
      }
      if (event.key === 'Enter') {
        if (event.repeat) {
          // Ngăn nếu đang giữ Enter
          event.preventDefault();
          return;
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  return <RouterProvider router={createRouter()} />;
}

export default App;
